import { forwardRef, useEffect, useRef, useState, useImperativeHandle } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { ProgressSpinner } from "primereact/progressspinner";

import OfferRewardFreeList from "./freeproduct/offer-reward-free-list";
import OfferRewardDiscountList from "./discount/offer-reward-discount-list";
import OfferRewardVoucherList from "./voucher/offer-reward-voucher-list";
// import OfferRewardDiscountList from "./discount/offer-reward-discount-list";
// import OfferRewardVoucherList from "./voucher/offer-reward-voucher-list";

const OfferRewardListMain = forwardRef((props, ref) => {
  const { onClickRowEditFree, onClickRowEditDiscount, onClickRowEditVoucher } = props;
  const freeRef = useRef(null);
  const voucherRef = useRef(null);
  const discountRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(0);

  // expose imperative methods to parent by delegating to active tab's child ref
  useImperativeHandle(ref, () => ({
    fetchListData: ({ page, take } = {}) => {
      const refs = [freeRef, voucherRef, discountRef];
      const current = refs[activeIndex]?.current;
      if (current && typeof current.fetchListData === "function") {
        current.fetchListData({ page, take });
      }
    },
    handleOnUpdateViewRow: (row) => {
      const refs = [freeRef, voucherRef, discountRef];
      const current = refs[activeIndex]?.current;
      if (current && typeof current.handleOnUpdateViewRow === "function") {
        current.handleOnUpdateViewRow(row);
      }
    },
    handleOnDeleteViewRow: (row) => {
      const refs = [freeRef, voucherRef, discountRef];
      const current = refs[activeIndex]?.current;
      if (current && typeof current.handleOnDeleteViewRow === "function") {
        current.handleOnDeleteViewRow(row);
      }
    },
    handleOnClickRefresh: () => {
      const refs = [freeRef, voucherRef, discountRef];
      const current = refs[activeIndex]?.current;
      if (current && typeof current.handleOnClickRefresh === "function") {
        current.handleOnClickRefresh();
      }
    },
  }), [activeIndex]);

  // use effect section

  // useEffect(() => {
  //   console.log("setActiveIndex", activeIndex);
  // }, [activeIndex]);

  //  custom ui section

  return (
    <div className="elevated-card-tight-vertical w-full">
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header="Package">
          <OfferRewardFreeList
            ref={freeRef}
            onClickRowEdit={onClickRowEditFree}
          />
        </TabPanel>
        {/* <TabPanel header="Voucher">
          <OfferRewardVoucherList
            ref={freeRef}
            onClickRowEdit={onClickRowEditVoucher}
          />
        </TabPanel>
        <TabPanel header="Discount">
          <OfferRewardDiscountList
            ref={freeRef}
            onClickRowEdit={onClickRowEditDiscount}
          />
        </TabPanel> */}
      </TabView>
    </div>
  );
});

export default OfferRewardListMain;
